import { Fragment } from "react";
import { Box, GridItem, Text } from "@chakra-ui/react";
import NumberField from "../../../../../../components/NumberField/NumberField";
import * as React from "react";

function GroupRows({ items, itemsType, labelSpan, valueSpan }) {
  return items && items.map(item => {
    return <Fragment key={`${itemsType}-${item.label}`}>
      <GridItem colSpan={labelSpan ?? 1}>
        <Box inlineSize="400px">
          <Text
            display="flex"
            justifyContent="start"
            alignItems="center"
            fontSize="sm"
            whiteSpace="break-spaces"
            marginLeft={6}
          >
            {item.label}
          </Text>
        </Box>
      </GridItem>
      <GridItem colSpan={valueSpan ?? 1}>
        <NumberField value={item.value} />
      </GridItem>
    </Fragment>;
  });
}

export default GroupRows;